import { render, staticRenderFns } from "./MinhasRasgadinhas.vue?vue&type=template&id=265f0346&"
import script from "./MinhasRasgadinhas.vue?vue&type=script&lang=js&"
export * from "./MinhasRasgadinhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports